import { useEffect } from 'react';
import { checkAndSetAffiliateFromUrl, getAffiliateCookie } from '@/lib/affiliateCookies';

/**
 * Hook to handle affiliate referral tracking
 * Place this in your root App component or layout
 */
export function useAffiliateTracking() {
  useEffect(() => {
    // Check URL for affiliate code on mount
    checkAndSetAffiliateFromUrl();
  }, []);

  return {
    getReferralData: getAffiliateCookie,
  };
}
